import React from "react"

const Head = () => {
  return (
    <>
      <section className='head'>
        <div className='container d_flex hd'>
          <div className='left row ft'>
            <i className='fa fa-phone'></i>
            <label> +2347089411190</label>
            <i className='fa fa-envelope'></i>
          </div>
          <div className='right roW RText ft'>
            <label>Theme FAQ"s</label>
            <label>Need Help?</label>
            <span>🏳️‍⚧️</span>
            <label>EN</label>
            <span>🏳️‍⚧️</span>
            <label>USD</label>
          </div>
        </div>
      </section>
    </>
  )
}

export default Head
